import { Column } from '../../cms/objects/column';
import {
    LockableFareActiveOptionFilters,
    LockableFareActiveOptionListConfiguration,
    LockableFareActiveOptionListCriteria,
} from '../objects/lockableFareActiveOption';

export const LOCKABLE_FARE_ACTIVE_OPTION_MODULE = 'LOCKABLE_FARE_ACTIVE_OPTION';

// Colonnes groupées visuellement dans le head (entête OPTION bleu / PAIEMENT vert)
export const OPTION_GROUP_FIELDS = ['OPTION_STATUS', 'OPTION_EXPIRY', 'OPTION_ACTIONS'];
export const PAYMENT_GROUP_FIELDS = ['PAYMENT_STATUS', 'AMOUNT', 'PAYMENT_ACTIONS'];

// Largeurs génériques (DEFAULT / MIN / CHECKBOX) partagées : app/component/utils/list/utils/columnResize.
export const ACTIONS_COLUMN_WIDTH = 90;
export const HISTORY_COLUMN_WIDTH = 80;

// Colonnes partagées entre les deux sous-menus
const SHARED_LEFT_COLUMNS: Column[] = [
    { label: 'trip-ref', field_name: 'TRIP_REF', checked: true, order_by: 'trip_reference', fixed_width: true, last_updated: false, width: null },
    { label: 'client', field_name: 'CLIENT', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'destination', field_name: 'DESTINATION', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'pax', field_name: 'PAX', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'start', field_name: 'START_DATE', checked: true, order_by: 'start_date', fixed_width: true, last_updated: false, width: null },
    { label: 'end', field_name: 'END_DATE', checked: true, order_by: 'end_date', fixed_width: true, last_updated: false, width: null },
    { label: 'channel', field_name: 'CHANNEL', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'agent', field_name: 'AGENT', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'tags', field_name: 'TAGS', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'option-set-at', field_name: 'OPTION_SET_AT', checked: false, order_by: 'option_set_at', fixed_width: true, last_updated: false, width: null },
];
const SHARED_RIGHT_COLUMNS: Column[] = [
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false, width: null },
];

// Sous-menu "Pose d'option" : colonnes OPTION uniquement, pas de colonnes paiement
export const DEFAULT_LOCKABLE_FARE_OPTION_COLUMNS: Column[] = [
    ...SHARED_LEFT_COLUMNS,
    { label: 'option-status', field_name: 'OPTION_STATUS', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'option-expiry', field_name: 'OPTION_EXPIRY', checked: true, order_by: 'option_expiry_date', fixed_width: true, last_updated: false, width: null },
    { label: 'option-actions', field_name: 'OPTION_ACTIONS', checked: true, order_by: '', fixed_width: false, last_updated: false, width: ACTIONS_COLUMN_WIDTH },
    ...SHARED_RIGHT_COLUMNS,
];

// Sous-menu "Booking" : colonnes PAIEMENT visibles, OPTION masquées
export const DEFAULT_LOCKABLE_FARE_BOOKING_COLUMNS: Column[] = [
    ...SHARED_LEFT_COLUMNS,
    { label: 'option-status', field_name: 'OPTION_STATUS', checked: false, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'option-expiry', field_name: 'OPTION_EXPIRY', checked: false, order_by: 'option_expiry_date', fixed_width: true, last_updated: false, width: null },
    { label: 'option-actions', field_name: 'OPTION_ACTIONS', checked: false, order_by: '', fixed_width: false, last_updated: false, width: ACTIONS_COLUMN_WIDTH },
    { label: 'payment-status', field_name: 'PAYMENT_STATUS', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'amount', field_name: 'AMOUNT', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'payment-actions', field_name: 'PAYMENT_ACTIONS', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    ...SHARED_RIGHT_COLUMNS,
];

// Conservé pour la config initiale du reducer (même valeur que OPTION par défaut)
export const DEFAULT_LOCKABLE_FARE_ACTIVE_OPTION_COLUMNS: Column[] = DEFAULT_LOCKABLE_FARE_OPTION_COLUMNS;

export const EMPTY_LOCKABLE_FARE_ACTIVE_OPTION_FILTERS: LockableFareActiveOptionFilters = {
    status: [],
    payment_status: [],
    version_type: [],
    source: [],
    agencies: [],
    markets: [],
    networks: [],
    period: 'CREATION',
    period_type: 0,
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    expiry_date_gte: null,
    expiry_date_lte: null,
    check_in_gte: null,
    check_in_lte: null,
    booking_date_gte: null,
    booking_date_lte: null,
};

// Champs date des filtres → réhydratés (string ISO → Date) à l'application d'un preset.
// Passés à useListFilterPresets({ dateFields }) ; la logique est générique (utils/list/utils/rehydrateFilterDates).
export const LOCKABLE_FARE_DATE_FILTER_FIELDS: (keyof LockableFareActiveOptionFilters)[] = [
    'created_date_gte', 'created_date_lte',
    'modified_date_gte', 'modified_date_lte',
    'expiry_date_gte', 'expiry_date_lte',
    'check_in_gte', 'check_in_lte',
    'booking_date_gte', 'booking_date_lte',
];

export const EMPTY_LOCKABLE_FARE_ACTIVE_OPTION_LIST_CONFIGURATION: LockableFareActiveOptionListConfiguration = {
    columns: DEFAULT_LOCKABLE_FARE_ACTIVE_OPTION_COLUMNS,
    preferences: [],
};

export const EMPTY_LOCKABLE_FARE_ACTIVE_OPTION_LIST_CRITERIA: LockableFareActiveOptionListCriteria = {
    limit: 25,
    page: 0,
    order: 'asc',
    order_by: 'option_expiry_date',
    search: '',
    filters: EMPTY_LOCKABLE_FARE_ACTIVE_OPTION_FILTERS,
};
